module.exports = __webpack_public_path__ + "img/icon-nav6.0d8e63b4.svg";